import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { CustomTranslateLoader } from 'src/app/translate/custom-translate.loader';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ThemeService } from '@services/theme.service';
import { Observable } from 'rxjs';
import { TTheme } from '@models/colors.model';
import { distinctUntilChanged, first } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { ToggleComponent } from '../../../shared/components/toggle/toggle.component';
import { ComponentCardComponent } from '../token/sd-dashboard/dashboard-components/component-card/component-card.component';

@UntilDestroy()
@Component({
  selector: 'view-settings',
  templateUrl: './settings.component.html',
  standalone: true,
  imports: [ReactiveFormsModule, ToggleComponent, TranslateModule, ComponentCardComponent],
})
export class SettingsComponent implements OnInit {
  // @HostBinding('class') class = ['settings-modal']
  readonly languages = [
    {
      id: 'en',
      value: 'English',
    },
    {
      id: 'zh',
      value: '中文',
    },
    {
      id: 'nl',
      value: 'Nederlands',
    },
  ];

  settingsForm: FormGroup;

  toggle: boolean;
  languageItems = [];
  languageControl: UntypedFormControl;
  themeControl: UntypedFormControl;

  constructor(
    private cutomTranslateLoader: CustomTranslateLoader,
    private themeService: ThemeService,
    private fb: UntypedFormBuilder,
  ) {}

  get theme$(): Observable<TTheme> {
    return this.themeService.theme$;
  }

  ngOnInit(): void {
    this.settingsForm = this.fb.group({
      language: [this.cutomTranslateLoader.getLanguage()],
      darkMode: false,
    });
    this.settingsForm.controls.darkMode.disable();
    this.settingsForm.controls.language.disable();

    this.initSubscriptions();
  }

  initSubscriptions(): void {
    this.theme$.pipe(first()).subscribe((value: TTheme) => {
      this.settingsForm.patchValue({ darkMode: value === 'dark' });
    });

    this.settingsForm
      .get('darkMode')
      .valueChanges.pipe(untilDestroyed(this), distinctUntilChanged())
      .subscribe((isDarkMode: boolean) => {
        this.themeService.theme = isDarkMode ? 'dark' : 'light';
      });

    this.settingsForm
      .get('language')
      .valueChanges.pipe(untilDestroyed(this), distinctUntilChanged())
      .subscribe((lang: string) => {
        this.cutomTranslateLoader.setLanguage(lang);
      });
  }

  onClose = () => {
    this['closeModal']();
  };
}
